import ModalStatusCreate from './ModalStatusCreate';
import ModalStatusDelete from './ModalStatusDelete';
import ModalStatusFilter from './ModalStatusFilter';
import ModalStatusUpdate from './ModalStatusUpdate';

export default Object.assign(
  {},
  {
    Create: ModalStatusCreate,
    Update: ModalStatusUpdate,
    Delete: ModalStatusDelete,
    Filter: ModalStatusFilter,
  },
);
